import axios from 'axios';

type ApiErrorPayload = {
  error_message?: string;
  message?: string;
  error?: string;
};

/** Ошибки полей из ответа 422 `{ error, fieldErrors: { key: message } }`. */
export const getApiFieldErrors = (error: unknown): Record<string, string> => {
  if (!axios.isAxiosError(error)) return {};
  const data = error.response?.data as { fieldErrors?: Record<string, string> } | undefined;
  return data?.fieldErrors ?? {};
};

export const getApiErrorMessage = (
  error: unknown,
  fallback = 'Произошла ошибка. Попробуйте еще раз.',
): string => {
  if (axios.isAxiosError(error)) {
    const data = error.response?.data as ApiErrorPayload | string | undefined;
    if (typeof data === 'string' && data.trim()) return data;
    if (data && typeof data === 'object') {
      if (data.error_message) return data.error_message;
      if (data.message) return data.message;
      if (data.error) return data.error;
    }
    if (error.message && !/^Request failed with status code \d+$/.test(error.message)) {
      return error.message;
    }
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
};

